module.exports = __webpack_public_path__ + "07_bob_brown.d1029058.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/07_bob_brown.png
// module id = NgYI
// module chunks = 0